import {PhaseResource} from "client/resources";
import {union} from "lodash";

const envCount = (phase: PhaseResource): number => {
    return union(phase.AutomaticDeploymentTargets, phase.OptionalDeploymentTargets).length;
};

export default envCount;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/library/components/Lifecycle/LifecycleMap/envCount.ts